import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isSalesForceInitialized } from '../selectors';
import ChatButton from './ChatButton';
import ChatTriggerIcon from './ChatTriggerIcon';

const ChatTriggerButton = ({ isSalesForceChatInitialized }: $TSFixMe) => {
    if (!isSalesForceChatInitialized) {
        return null;
    }

    return (
        <ChatButton>
            <ChatTriggerIcon />
        </ChatButton>
    );
};
export default connect(
    createStructuredSelector({
        isSalesForceChatInitialized: isSalesForceInitialized,
    })
)(ChatTriggerButton);
